<template>
  <div class="horizontal-field-layout">
    <div
      class="horizontal-field-label"
      :style="{width: `${labelWidth}%`}"
    >
      {{ label }}
    </div>
    <div :style="{width: `${fieldWidth}%`}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalFieldLayout',
  props: {
    label: {
      type: String,
      required: true
    },
    labelFieldRatio: {
      type: String,
      default: '1/2'
    }
  },
  computed: {
    labelRatio () {
      return Number(this.labelFieldRatio.split('/')[0])
    },
    fieldRatio () {
      return Number(this.labelFieldRatio.split('/')[1])
    },
    labelWidth () {
      return (100 / (this.labelRatio + this.fieldRatio)) * this.labelRatio
    },
    fieldWidth () {
      return 100 - this.labelWidth
    }
  }
}
</script>

<style scoped>
.horizontal-field-layout {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.horizontal-field-label {
  display: flex;
  align-items: center;
}
</style>
